module.exports = __webpack_public_path__ + "img/shijihualian.f32f574d.png";